module.exports = __webpack_public_path__ + "img/15.42ed7468.jpg";